module.exports = __webpack_public_path__ + "static/img/16yr old girl.edc4cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/16yr old girl.jpg
// module id = C1ra
// module chunks = 1